module.exports = __webpack_public_path__ + "img/MiniVer.71bfe42c.png";